// Transportní obal QR payloadu na deep-link URL. Payload formát se nemění,
// jen se zabalí do <origin><mobileBase>?cmd=<urlencoded payload>.
import type { ClipboardCode, ClipboardService, ClipboardTicket } from '@/stores/clipboard'

// Odvodí mobilní base path z admin base path nahrazením segmentu admin→mobile.
//   /static/bzuco_guard/admin-next/ → /static/bzuco_guard/mobile-next/
//   /admin-next/ → /mobile-next/      /admin/ → /mobile/
// Robustní vůči budoucímu odstranění '-next'.
export function mobileBasePath(adminBase: string): string {
    return adminBase.replace(/\badmin(-next)?\//, 'mobile$1/')
}

// Sestaví deep-link URL z holého payloadu. `origin` a `base` jsou volitelné
// kvůli testovatelnosti; v aplikaci se použije window.location.origin a
// VITE_APP_BASE.
export function buildDeepLink(payload: string, origin?: string, base?: string): string {
    const o = origin ?? window.location.origin
    const b = base ?? mobileBasePath(import.meta.env.VITE_APP_BASE || '/')
    return `${o}${b}?cmd=${encodeURIComponent(payload)}`
}

// Mobilem-proveditelné service kódy. Ostatní (server/wifi/display/start-update/
// reset) jsou HW-only a deep-link by v mobilu vedl na "nerozpoznaný".
const DEEP_LINKABLE_SERVICE = ['counter', 'language', 'scan-info']

// True pro kódy, které mobil umí provést → generovat deep-link URL.
export function isDeepLinkable(code: ClipboardCode | ClipboardService | ClipboardTicket): boolean {
    if (code.kind === 'service') {
        return DEEP_LINKABLE_SERVICE.includes(code.service.kind)
    }
    if (code.kind === 'ticket') {
        return false // a ticket QR is the bare EAN — read as a ticket, never wrapped
    }
    return true // ticketsets | zones | login
}
